// src/CheckIcon.tsx
import { jsx } from "react/jsx-runtime";
var CheckIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "check-icon",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M20 6 9 17l-5-5" })
  }
);
var CheckIcon_default = CheckIcon;

export {
  CheckIcon_default
};
